import { ErrorMessage } from "formik";
import React, { Component } from "react";
import SelectMulti from "components/SelectMulti/selectmulti.component";
import Input from "../../components/Input/input.component";
import { numberMask } from "../../components/Input/Masks";
import WidgetModalForm, {
	ModalFormContext
} from "../../components/Modal/modalForm.component";
import Required from "../../components/Required/required.component";
import estoqueService from "../../services/estoqueService";
import { MovimentacaoValidationSchema } from "./entrada.modal.validates";
import { connect } from "react-redux";

const mapStateToProps = state => ({ usuario: state.auth.usuario });

class MovimentacaoModal extends Component {
	constructor(props) {
		super(props);
		this.handleOnChangeOrigem = this.handleOnChangeOrigem.bind(this);
		this.state = {
			estoqueOrigem: {
				quantidadeDisponivel: "--"
			},
			estoqueDestino: {
				quantidadeDisponivel: "--"
			},
			movimentacao: {
				destino: {
					id: ""
				},
				origem: {
					id: ""
				},
				quantidade: "",
				recebedor: ""
			},
			estoques: [],
			estoquesDestino: []
		};
	}

	async componentDidMount() {
		const { dacaId } = this.props;
		const estoqueResponse = await estoqueService.findByDacaId(dacaId);
		console.log(estoqueResponse.data);
		this.setState({ estoques: estoqueResponse.data });
	}

	async handleOnChangeOrigem(item, setFieldValue) {
		const { dacaId } = this.props;
		const { estoques, estoqueDestino } = this.state;

		const origemId = item.object.id;
		const estoqueDestinoResponse = await estoqueService.findOrigemByDacaId(
			dacaId,
			origemId
		);
		const estoqueOrigem = estoques.find(e => e.id === Number(origemId));

		if (!estoqueOrigem) {
			const estoqueOrigemClean = { quantidadeDisponivel: "--" };
			this.setState({ estoqueOrigem: estoqueOrigemClean });
		} else {
			this.setState({ estoqueOrigem });
		}
		const estoquesDestino = estoqueDestinoResponse.data;
		this.setState({ estoquesDestino });
		if (estoqueDestino) {
			const isEstoqueDestinoListed = estoqueDestinoResponse.data.find(
				e => e.id === Number(estoqueDestino.id)
			);
			if (!isEstoqueDestinoListed) {
				this.setState({
					estoqueDestino: { quantidadeDisponivel: "--" }
				});
				setFieldValue("destino", { id: "" });
			}
		}

		if (this.limpaSelectOrigemDestino("origem")) {
			setFieldValue("destino", { id: "" });
		}

		setFieldValue("origem.id", origemId);
	}

	async handleOnChangeDestino(item, setFieldValue) {
		const { estoquesDestino } = this.state;
		const destinoId = item.object.id;
		const estoqueDestino = estoquesDestino.find(
			e => e.id === Number(destinoId)
		);
		if (!estoqueDestino) {
			const estoqueDestinoClean = { quantidadeDisponivel: "--" };
			this.setState({ estoqueDestino: estoqueDestinoClean });
		} else {
			this.setState({ estoqueDestino });
		}
		if (this.limpaSelectOrigemDestino("destino")) {
			setFieldValue("origem", { id: "" });
		}
		setFieldValue("destino.id", destinoId);
	}

	limpaSelectOrigemDestino(tipo) {
		const { estoqueDestino, estoqueOrigem } = this.state;

		if (estoqueDestino.id && estoqueOrigem.id) {
			if (tipo === "origem") {
				if (estoqueDestino.id === estoqueOrigem.id) {
					this.setState({
						estoqueDestino: { quantidadeDisponivel: "--" }
					});
					return true;
				}
			}

			if (tipo === "destino") {
				if (estoqueDestino.id === estoqueOrigem.id) {
					this.setState({
						estoqueOrigem: { quantidadeDisponivel: "--" }
					});
					return true;
				}
			}
		}
		return false;
	}

	filterEstoque() {
		const { estoques } = this.state;
		return estoques;
	}

	render() {
		const {
			isOpenMovimentacao,
			handleCloseMovimentacao,
			handleSalvarMovimentacao,
			nomeDaca
		} = this.props;

		const {
			movimentacao,
			estoquesDestino,
			estoqueOrigem,
			estoqueDestino
		} = this.state;

		return (
			<WidgetModalForm
				textCancelar="Cancelar"
				textConfirmar="Cadastrar"
				initialValues={movimentacao}
				validationSchema={MovimentacaoValidationSchema}
				title="Registrar movimentação de estoque"
				confirmar={handleSalvarMovimentacao}
				isOpen={isOpenMovimentacao}
				cancelar={handleCloseMovimentacao}
				modalConfirmarFechar
				modalConfirmarCancelar
				modalConfirmarCancelarTitulo="Atenção!"
				modalConfirmarCancelarCorpo="Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos."
				iconCancelar="fas fa-times"
				iconConfirmar="fas fa-save"
			>
				<ModalFormContext.Consumer>
					{({ values, handleChange, setFieldValue }) => (
						<div>
							<div className="row">
								<div className="col-12">
									<p>
										<strong>Item:</strong> {nomeDaca}{" "}
									</p>
								</div>
								<div className="col-md-6 form-group">
									<label>
										Origem: <Required />
									</label>

									<SelectMulti
										label="nomeTipoEstoque"
										name="origem.id"
										className="form-control form-control-sm"
										onChange={item => {
											this.handleOnChangeOrigem(
												item,
												setFieldValue
											);
										}}
										value={values.origem}
										options={this.filterEstoque()}
									/>

									<ErrorMessage
										name="origem.id"
										render={msg => (
											<span className="text-danger">
												{msg}
											</span>
										)}
									/>
								</div>
								<div className="col-md-6 form-group">
									<label>
										Destino: <Required />
									</label>
									<SelectMulti
										name="destino.id"
										label="nomeTipoEstoque"
										onChange={item =>
											this.handleOnChangeDestino(
												item,
												setFieldValue
											)
										}
										value={values.destino}
										options={estoquesDestino}
									/>
									<ErrorMessage
										name="destino.id"
										render={msg => (
											<span className="text-danger">
												{msg}
											</span>
										)}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-md-6">
									<label>Saldo atual da origem:</label>
									<p>
										{estoqueOrigem
											? estoqueOrigem.quantidadeDisponivel
											: "--"}
									</p>
								</div>
								<div className="col-md-6">
									<label>Saldo atual do destino:</label>
									<p>
										{estoqueDestino
											? estoqueDestino.quantidadeDisponivel
											: "--"}
									</p>
								</div>
							</div>
							<div className="row">
								<div className="col-md-12 form-group">
									<label>
										Quantidade: <Required />
									</label>
									<Input
										maxLength="18"
										name="quantidade"
										type="text"
										mask={numberMask}
										onChange={handleChange}
										value={values.quantidade}
									/>
									<ErrorMessage
										name="quantidade"
										render={msg => (
											<span className="text-danger">
												{msg}
											</span>
										)}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-md-12 form-group">
									<label>
										Recebedor: <Required />
									</label>
									<Input
										name="recebedor"
										bsSize="sm"
										onChange={handleChange}
									/>
									<ErrorMessage
										name="recebedor"
										render={msg => (
											<span className="text-danger">
												{msg}
											</span>
										)}
									/>
								</div>
							</div>
						</div>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}

export default connect(mapStateToProps)(MovimentacaoModal);
